export const OTHER_COUNTRY_CODE = "ZZ";
